import tmhRequest from '@/config/tmhRequest'

export default {
    searchListConsumeMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusreport/searchlistconsumememberstatusreport',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportConsumeMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusreport/exportconsumememberstatusreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/consumememberstatusreport.js